function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1 3.952C1 2.874 1.884 2 2.974 2h10.052C14.116 2 15 2.874 15 3.952v.701a.4.4 0 010 .016v6.38A1.963 1.963 0 0113.026 13H2.974A1.963 1.963 0 011 11.048v-6.38-.716zm1.077 1.704v5.392c0 .49.402.887.897.887h10.052a.892.892 0 00.897-.887V5.656L9.095 8.837a1.994 1.994 0 01-2.19 0L2.077 5.656zm11.846-1.28L8.498 7.952a.906.906 0 01-.996 0L2.077 4.376v-.424c0-.49.402-.887.897-.887h10.052c.495 0 .897.397.897.887v.424z",
  fill: "#2D2D2D"
});
function SvgCorreo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Correo.svg";
export { SvgCorreo as ReactComponent };